module.exports = __webpack_public_path__ + "img/rush-logo-new.56a90363.svg";